import { ItinTag } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import { useMemo } from 'react'
import { useShallow } from 'zustand/react/shallow'
import { useBoundStore } from '../../state/bound.store'
interface ITagsListProps {
    tagIds: number[]
}
export const ItinTagsList = ({ tagIds }: ITagsListProps) => {
    const { tags } = useBoundStore(
        useShallow((s) => {
            return {
                tags: s.orgConfig?.itinTags ?? [],
            }
        })
    )
    const selectedTags = useMemo(() => {
        return tags.filter((tag) => tagIds.includes(tag.id)) // Filter tags based on tagIds
    }, [tags, tagIds])

    return (
        <Stack gap={'4px'} flexWrap={'wrap'} direction={'row'}>
            {selectedTags.map((tag, index) => (
                <ItinTag
                    tag={tag.name}
                    colour={tag.colour}
                    key={index}
                    tagExpended
                ></ItinTag>
            ))}
        </Stack>
    )
}
